import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { throwIfNotOk } from '../throwIfNotOk';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/scene/upload-thumbnail', 'post'>;

type Params = {
  sceneId: number;
  thumbnail: File;
};

export const uploadSceneThumbnailFactory = (apiClient: ApiClient) => {
  const uploadSceneThumbnail = async (variables: Params): Promise<void> => {
    const requestParams = mapInputToRequestParams(variables);
    const response = await apiClient['/api/scene/upload-thumbnail'].post(requestParams);
    await throwIfNotOk(response, 'upload the scene thumbnail');
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      formData: {
        sceneId: input.sceneId,
        formFile: input.thumbnail,
      },
    };
  };

  return uploadSceneThumbnail;
};
